import { z } from 'zod';

import { BaseItemSchema } from '../common.js';
import { HumanTaskCategoryStatus } from '../flow/humanTask/humanTaskCategory.js';
import { oneOrMany } from '../utils.js';

export const BaseAssignmentGroupSchema = z.object({
  name: z.string().min(1),
  description: z.string(),
  organizationId: z.string().uuid(),
  state: z.nativeEnum(HumanTaskCategoryStatus),
});
export type BaseAssignmentGroup = z.infer<typeof BaseAssignmentGroupSchema>;

export const AssignmentGroupSchema = BaseAssignmentGroupSchema.extend({
  ...BaseItemSchema.shape,
});
export type AssignmentGroup = z.infer<typeof AssignmentGroupSchema>;

export type AssignmentGroupBasic = Pick<AssignmentGroup, 'id' | 'name'>;

export const AssignmentGroupQueryParamsSchema = z.object({
  id: oneOrMany(z.string().uuid()).optional(),
  organizationId: oneOrMany(z.string().uuid()).optional(),
  q: z.string().optional(),
  name: z.string().optional(),
  state: z.nativeEnum(HumanTaskCategoryStatus).optional(),
  limit: z.coerce.number().positive().optional(),
  offset: z.coerce.number().min(0).optional(),
});
export type AssignmentGroupQueryParams = z.infer<typeof AssignmentGroupQueryParamsSchema>;
